import { makeStyles, Theme } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    form: {
      width: '100%',
    },
    btnContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      margin: '16px 0 32px',
      '@media (max-width: 599px)': {
        justifyContent: 'center',
        margin: '8px 0 16px',
      },
    },

    btn: {
      backgroundColor: '#E2222B',
      fontWeight: 500,
      fontStyle: 'Regular',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      height: '48px',
      width: '216px',
      borderRadius: '4px',
      textTransform: 'capitalize',
      color: '#FFFFFF',
      padding: theme.spacing(1, 5),
      whiteSpace: 'nowrap',
      '@media (max-width: 599px)': {
        width: '100%',
        fontSize: '14px',
        height: '44px',
      },
    },
    formContainer: {
      backgroundColor: '#ffffff',
      borderRadius: '4px 4px 4px 4px',
      padding: '32px',
      width: '100%',
      '@media (max-width: 959px)': {
        padding: '24px',
      },
      '@media (max-width: 599px)': {
        padding: '16px',
      },
    },
    block: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    rightCol: {
      width: '100%',
    },
    row: {
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginBottom: theme.spacing(2),
      flexBasis: '45%',
      flexWrap: 'wrap',
      '@media (max-width: 959px)': {
        flexBasis: '100%',
      },
      '@media (max-width: 599px)': {
        flexBasis: '100%',
        marginBottom: '16px',
      },
    },
    input: {
      minWidth: 250,
      flexGrow: 1,
      fontSize: 16,
      color: 'rgb(0 0 0 / 87%)',
      '& .MuiInputBase-input.Mui-disabled': {
        color: 'rgb(0 0 0 / 87%)',
      },
      '@media (max-width: 599px)': {
        minWidth: '100%',
      },
    },
    heading: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 550,
      fontSize: '20px',
      lineHeight: '27px',
      color: '#000000',
      margin: '24px 0',
      background: 'background: rgba(0, 0, 0, 1)',
      padding: '10px 16px',
    },

    leftCol: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginBottom: '24px',
      '@media (max-width: 599px)': {
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '32px',
      },
    },
    profilePicture: {
      borderRadius: '50%',
      width: 100,
      height: 100,
      '@media (max-width: 599px)': {
        width: '80px',
        height: '80px',
      },
    },
    profileContainer: {
      minWidth: '100px',
      borderRadius: '50%',
      marginRight: '24px',
      '@media (max-width: 599px)': {
        marginRight: '0px',
        marginBottom: '8px',
      },
    },
    uploadBtnContainer: {
      minWidth: '216px',
      gap: '12px',
      borderRadius: '4px',
      marginRight: '24px',
      '@media (max-width: 599px)': {
        marginRight: '0px',
        marginBottom: '8px',
        minWidth: '100%',
      },
    },
    removeBtnContainer: {
      width: '107px',
      gap: '12px',
      borderRadius: '4px',
      marginRight: '24px',
      '@media (max-width: 599px)': {
        marginRight: '0px',
        width: '100%',
      },
    },
    tooltip: {
      fontSize: '10px',
      lineHeight: 'auto',
      height: '56px',
    },
    link2: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontStyle: 'Regular',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      height: '48px',
      width: '216px',
      borderRadius: '4px',
      padding: theme.spacing(1, 5),
      textTransform: 'none',
      whiteSpace: 'nowrap',
      '@media (max-width: 599px)': {
        width: '100%',
        fontSize: '14px',
        height: '44px',
      },
    },

    value: {
      fontSize: 34,
      marginBottom: theme.spacing(1),
    },
    yesValue: {
      fontSize: 20,
    },
    title: {
      flexGrow: 1,
      maxWidth: 280,
      //height: 60,
      fontSize: 16,
      marginBottom: theme.spacing(3),
      color: '#757575',
    },
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
    },
    gridPaper: {
      height: '140px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      padding: '16px',
      boxSizing: 'border-box',
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    fixedHeight: {
      height: 240,
    },
    logo: {
      margin: theme.spacing(2),
    },
    alert: {
      margin: '20px 0',
      padding: 20,
      backgroundColor: '#ffcc00',
      borderRadius: 10,
    },
    infoContainer: {
      display: 'flex',
      marginBottom: theme.spacing(1),
      alignItems: 'stretch',
    },
    link: {
      display: 'inline-block',
      textTransform: 'uppercase',
      color: theme.palette.info.main,
      letterSpacing: 0.4,
      fontSize: 14,
      //marginLeft: theme.spacing(1),
      //fontWeight: 600,
      margin: `0 ${theme.spacing(3)}px 0 0`,
    },
    disabledLink: {
      display: 'inline-block',
      textTransform: 'uppercase',
      color: grey[500],
      letterSpacing: 0.4,
      fontSize: 14,
      margin: `0 ${theme.spacing(3)}px 0 0`,
    },
    tabsPaper: {
      boxShadow: theme.shadows[0],
      backgroundColor: 'transparent',
    },
    tabs: {
      width: 'fit-content',
      border: '1px solid white',
      borderRadius: '4px 0px 0px 4px',
      background: 'white',
      '& .MuiTabs-indicator': {
        backgroundColor: 'orange',
        height: 3,
      },
      '& .MuiTab-root.Mui-selected': {
        color: 'white',
        backgroundColor: '#5081FF',
      },
      '& .MuiTab-root': {
        padding: '16px 24px',
      },
    },
    desc: {
      width: '30%',
      fontSize: 16,
      padding: 5,
      color: 'rgb(0 0 0 / 87%)',
    },
  }),
  {
    index: 1,
  }
);
